// @file utility functions related to posts (wishes)

import type { User } from '@padlet/arvo'
import { anonymous, isRegistered } from 'bits/user_model'

export function getAuthorDisplayName(user?: User): string {
  if (user == null) return ''
  if (!isRegistered(user)) {
    return anonymous
  }
  if (user.name != null && user.name !== '') {
    return user.name
  }
  if (user.username != null && user.username !== '') {
    return user.username
  }
  return ''
}
